import { render } from "./HiSelect.vue?vue&type=template&id=4765ed10"
import script from "./HiSelect.vue?vue&type=script&lang=js"
export * from "./HiSelect.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__